export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/daf0806c7a2ae5d4ef79656386229c6b.jpg"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0F1E]/90 via-[#0A0F1E]/65 to-[#0A0F1E]/30"></div>
      </div>

      <div className="relative w-full max-w-[1400px] mx-auto px-12 py-48">
        <div className="max-w-[780px] space-y-12">
          {/* Eyebrow */}
          <div className="flex items-center gap-5">
            <span className="block w-12 h-[1px] bg-[#C9A96E]"></span>
            <p className="text-[10px] font-semibold tracking-[0.24em] uppercase text-[#C9A96E]">
              Technology holding company
            </p>
          </div>

          {/* Headline */}
          <h1 className="text-6xl lg:text-[72px] font-light text-white leading-[1.1] tracking-[-0.025em]">
            Focused companies. Long-term value.
          </h1>

          {/* Subheadline */}
          <p className="text-[17px] text-white/60 leading-[1.7] max-w-[580px] font-light tracking-wide">
            Diivy is a holding company behind businesses in health technology, safety, and commerce, built with an operating mindset and a long-term approach to growth.
          </p>

          {/* CTAs */}
          <div className="flex items-center gap-10 pt-4">
            <a
              href="#portfolio"
              className="px-9 py-4 bg-[#C9A96E] text-[#0A0F1E] text-[13px] font-semibold tracking-[0.04em] rounded-sm hover:bg-[#B8955A] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              View Companies
            </a>
            <a
              href="#contact"
              className="text-[13px] font-medium text-white/65 hover:text-white inline-flex items-center gap-3 group whitespace-nowrap cursor-pointer transition-colors duration-300 tracking-wide"
            >
              Get in Touch
              <i className="ri-arrow-right-line text-base group-hover:translate-x-1.5 transition-transform duration-300"></i>
            </a>
          </div>

          {/* Parent Company Note */}
          <div className="pt-8 border-t border-white/10">
            <p className="text-[13px] text-white/40 font-light tracking-wide">
              Parent company of Diitect and Vetuvia.
            </p>
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-t from-[#F7F4EF] to-transparent"></div>
    </section>
  );
}